// AUTO GENERATED FILE - Changes WILL be lost.
// th - used as 'th' fallback
export const common_fallback = true

export const translations = {
  "betslip.title": "บิลเดิมพัน",
  "last60.fixture.pending": "{visitor} {'@'} {home}",
  "last60.fixture.result": "{visitor} ({visitorScore}) {'@'} ({homeScore}) {home}",
  "sb.fixture.pending": "{home} พบ {away}",
  "sb.fixture.result": "{home} {homeScore} - {awayScore} {away}",
  "betslip.bet": "วางเดิมพัน",
  "betslip.clear": "เคลียร์ทั้งหมด",
  "betslip.clearResult": "เคลียร์",
  "betslip.noSelections": "เพิ่มตัวเลือกเพื่อเริ่มเดิมพัน",
  "betslip.notLoggedIn": "ล็อกอินเพื่อเริ่มเดิมพัน",
  "betslip.refresh": "รีเฟรช",
  "betslip.totalStake": "เดิมพันทั้งหมด",
  "betslip.noHistoryData": "ไม่มีข้อมูลการเดิมพัน",
  "betslip.openBets": "เปิดเดิมพัน",
  "betslip.betHistory": "ประวัติเดิมพัน",
  "betslip.betHistoryWon": "ชนะ",
  "betslip.betHistoryLost": "แพ้",
  "loading.loading": "กำลังโหลด",
  "loading.account": "กำลังโหลดบัญชี",
  "loading.league": "กำลังโหลดลีก",
  "loading.gameweeks": "กำลังโหลดเกมส์ประจำสัปดาห์",
  "loading.markets": "กำลังโหลดตลาดเดิมพัน",
  "loading.bethistory": "กำลังโหลดประวัติเดิมพัน",
  "login.loginRequired": "กรุณาล็อกอิน",
  "login.loginToBet": "กรุณาล็อกอินเพื่อเริ่มเดิมพัน",
  "navigation.back": "กลับไป",
  "navigation.close": "ปิด",
  "video.liveStreamAvailable": "มีการถ่ายทอดสด",
  "video.logInToWatch": "กรุณาล็อคอินเพื่อรับชม",
  "error.error": "ผิดพลาด",
  "error.404": "ไม่พบหน้านี้",
  "error.gameLaunchFailed": "ไม่สามารถเปิดเกมส์ได้",
  "error.unknownErrorCode": "เกิดข้อผิดพลาด  {code}",
  "error.minUnitStakeLimitExceeded": "ยอดเดิมพันต่ำสุด {limit}",
  "error.maxUnitStakeLimitExceeded": "ยอดเดิมพันสูงสุด {limit}",
  "error.minTotalStakeLimitExceeded": "ยอดเดิมพันรวมต่ำสุด {limit}",
  "error.maxTotalStakeLimitExceeded": "ยอดเดิมพันรวมสูงสุด {limit}",
  "error.notPlaced": "วางเดิมพันไม่สำเร็จ",
  "error.wagerDisallowed": "ไม่สามารุเดิมพันได้",
  "error.errorEventIsOff": "รายการแข่งเริ่มต้นแล้ว",
  "wagerType.Singles": "ซิงเกิ้ล",
  "wagerType.Doubles": "ดับเบิ้ล",
  "wagerType.Trebles": "ทริปเปิ้ล",
  "wagerType.Accumulator": "เดิมพันสะสม",
  "wagerType.Perm 4-Folds": "4-โฟลด์",
  "wagerType.Perm 5-Folds": "5-โฟลด์",
  "wagerType.Perm 6-Folds": "6-โฟลด์",
  "wagerType.Perm 7-Folds": "7-โฟลด์",
  "wagerType.Perm 8-Folds": "8-โฟลด์",
  "wagerType.Perm 9-Folds": "9-โฟลด์",
  "sb-english.team.ARS": "อาร์เซนอล",
  "sb-english.team.AST": "แอสตัน",
  "sb-english.team.BHA": "ไบรท์ตัน",
  "sb-english.team.BOU": "บอร์นมัธ",
  "sb-english.team.BUR": "เบิร์นลีย์",
  "sb-english.team.CHE": "เชลซี",
  "sb-english.team.CRY": "พาเลซ",
  "sb-english.team.EVE": "เอฟเวอร์ตัน",
  "sb-english.team.LEI": "เลสเตอร์",
  "sb-english.team.LIV": "ลิเวอร์พูล",
  "sb-english.team.MNC": "แมนฯซิตี้",
  "sb-english.team.MNU": "ปีศาจแดง",
  "sb-english.team.NEW": "นิวคาสเซิล",
  "sb-english.team.SOU": "เซ้าแธมป์ตัน",
  "sb-english.team.TOT": "ท็อตแนม",
  "sb-english.team.WAT": "วัตฟอร์ด",
  "sb-english.team.WHU": "เวสต์แฮม",
  "sb-english.team.WOL": "วูล์ฟ",
  "sb-english.team.NOR": "นอริช",
  "sb-english.team.SHU": "เชฟฟิลด์",
  "sb-english.team.LEE": "ลีดส์",
  "sb-english.team.FUL": "ฟูแล่ม",
  "sb-english.team.WBA": "เวสต์บรอม",
  "nomorebets": "สิ้นสุดการเดิมพัน",
  "playtime": "เวลาเล่น",
  "gameId": "รหัสเกม",
  "noGames": "เกมส์ยังไม่เปิดให้บริการ โปรดตรวจสอบอีกครั้งเร็วๆนี้",
  "Home": "เจ้าบ้าน",
  "Away": "ทีมเยือน",
  "Visitor": "ผู้เยี่ยมชม",
  "soccerbet.gameWeek": "เกมส์ประจำสัปดาห์",
  "soccerbet.noGameWeeks": "ไม่มีเกมส์ประจำสัปดาห์ กรุณาเช็คอีกครั้ง",
  "soccerbet.league": "ตารางอันดับลีก",
  "soccerbet.table.name": "ชื่อ",
  "soccerbet.table.won": "ชนะ",
  "soccerbet.table.drawn": "เสมอ",
  "soccerbet.table.lost": "แพ้",
  "soccerbet.table.points": "แต้ม",
  "abbr.event.Both Teams To Score": "เดิมพันทีมที่จะทำสกอร์",
  "event.Both Teams To Score": "เดิมพันทีมที่จะทำสกอร์",
  "event.Over / Under": "สูง/ต่ำ",
  "event.Double Chance": "ดับเบิ้ลแชนซ์",
  "event.Match Result": "ผลการแข่งขัน",
  "event.Exact Goals": "ประตูจริง",
  "event.Correct Score": "ทายผลสกอร์",
  "event.Match Result Both Score": "ผลการแข่งขันทั้งสองทีมทำประตูได้",
  "event.Result Und/Over 1.5 Total Goals": "ผล สูง/ต่ำ 1.5 ประตูรวม",
  "event.Result Und/Over 2.5 Total Goals": "ผล สูง/ต่ำ 2.5 ประตูรวม",
  "event.Under Over 1.5 Total Goals": "สูง/ต่ำ 1.5 ประตูรวม",
  "event.Under Over 2.5 Total Goals": "สูง/ต่ำ 2.5 ประตูรวม",
  "event.Under Over 3.5 Total Goals": "สูง/ต่ำ 3.5 ประตูรวม",
  "event.Under Over 4.5 Total Goals": "สูง/ต่ำ 4.5 ประตูรวม",
  "event.Total Goals 1 To 2": "ประตูรวม 1 - 2",
  "event.Total Goals 1 To 3": "ประตูรวม 1 - 3",
  "event.Total Goals 1 To 4": "ประตูรวม 1 - 4",
  "event.Total Goals 2 To 3": "ประตูรวม 2 - 3",
  "event.Total Goals 2 To 4": "ประตูรวม 2 - 4",
  "event.Under Over 1.5 Home Goals": "สูง/ต่ำ 1.5 ประตูเจ้าบ้าน",
  "event.Under Over 1.5 Away Goals": "สูง/ต่ำ 1.5 ประตูทีมเยือน",
  "event.Home Team Exact Goals": "ประตูจริงทีมเหย้า",
  "event.Away Team Exact Goals": "ประตูจริงทีมเยือน",
  "selection.Yes": "ใช่",
  "selection.No": "ไม่ใช่",
  "selection.1+G": "1+ยิงประตู",
  "selection.1+Ng": "1+ไม่มีประตู",
  "selection.X+G": "X+ยิงประตู",
  "selection.X+Ng": "X+ไม่มีประตู",
  "selection.2+G": "2+ยิงประตู",
  "selection.2+Ng": "2+ไม่มีประตู",
  "selection.1+Yes": "1+ใช่",
  "selection.1+No": "1+ไม่ใช่",
  "selection.X+Yes": "X+ใช่",
  "selection.X+No": "X+ไม่ใช่",
  "selection.2+Yes": "2+ใช่",
  "selection.2+No": "2+ไม่ใช่",
  "selection.TID_ANY_GOAL_SCORED_YES": "ทำประตูได้",
  "selection.TID_ANY_GOAL_SCORED_NO": "ไม่มีประตู",
  "selection.U": "ต่ำ",
  "selection.O": "สูง",
  "selection.1+O": "1+สูง",
  "selection.X+O": "X+สูง",
  "selection.2+O": "2+สูง",
  "selection.1+U": "1+ต่ำ",
  "selection.X+U": "X+ต่ำ",
  "selection.2+U": "2+ต่ำ",
  "selection.TID_HOME_WIN": "1",
  "selection.TID_AWAY_WIN": "2",
  "selection.TID_DRAW": "X",
  "selection.TID_HOME_WIN_OR_DRAW": "1x",
  "selection.TID_DRAW_OR_AWAY_WIN": "x2",
  "selection.TID_HOME_OR_AWAY_WIN": "12"
}
